import React, { PureComponent } from 'react';
import { Translation } from 'react-i18next';
import CoinMarketContainer from '../containers/CoinMarketContainer';
import FooterComponent from './common/FooterComponent';
import BannerLandingComponent from './BannerLandingComponent';
import CampaignContainer from '../containers/CampaignContainer';
import ContactComponent from './ContactComponent';

class LandingComponent extends PureComponent {
  render() {
    return (
      <Translation>
        {(t) => (
          <div className="landing">
            <div className="landing-layout">
              <div className="landing__banner">
                <BannerLandingComponent />
              </div>
              <div className="landing__market max-width ma">
                <div className="mt-large">
                  <CoinMarketContainer isLandingPage />
                </div>
              </div>
              <div className="landing__notify">
                <i
                  className="icon-mdi_bell-alert-outline mr-small"
                  style={{ fontSize: 14, float: 'left', marginLeft: 5 }}
                />
                {t('landing.condition')}
                <div style={{
                  border: 'solid thin white', height: 20, marginLeft: 10, marginRight: 10,
                }}
                />
                <span className="pointer text-grey">{t('landing.more')}</span>
              </div>
              <div className="landing__carouselSlide">
                <CampaignContainer />
              </div>
              <div>
                <ContactComponent />
              </div>
              <div className="footer">
                <FooterComponent />
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default LandingComponent;
